import { ClientApp } from "models";

import { replace } from "utils/Utils";
import { UpdateTemplateEndAction } from "../actions/UpdateTemplate";
import { UploadTemplateEndAction } from "../actions/UploadTemplate";
import { AppPage, AppsMap, AppState } from "../state";

function addAppToPage(app: ClientApp, pages: AppPage = { apps: [] }): AppPage {
    pages.apps.push(app);
    return pages;
}

function addAppToLastPage(app: ClientApp, pages: AppPage[] = [{ apps: [] }]): AppPage[] {
    const end = pages.length - 1;
    const lastPage = pages[end];
    pages[end] = addAppToPage(app, lastPage);
    return pages;
}

export function addAppToState(
    state: AppState,
    action: { payload: { app?: ClientApp; error?: Error }; type: string }
): AppState {
    const { app, error } = action.payload;
    const errorMap = { ...state.errorMap };
    errorMap[action.type] = error;

    const appsMap: AppsMap = { ...state.appsMap };
    const appPagesMap = { ...state.appPagesMap };
    if (app) {
        appsMap[app.organizationId] = replace(appsMap[app.organizationId], app, "appId", true);
        appPagesMap[app.organizationId] = addAppToLastPage(app, appPagesMap[app.organizationId]);
    }
    return { ...state, appsMap, appPagesMap, errorMap };
}

export function updateApp(
    state: AppState,
    action: { payload: { app?: ClientApp; error?: Error }; type: string }
): AppState {
    const { app, error } = action.payload;
    const errorMap = { ...state.errorMap };
    errorMap[action.type] = error;

    const appsMap = { ...state.appsMap };
    const appPagesMap = { ...state.appPagesMap };
    if (app) {
        appsMap[app.organizationId] = replace(state.appsMap[app.organizationId], app, "appId");

        const pages = appPagesMap[app.organizationId] || [];
        pages.forEach(page => {
            page.apps = replace(page.apps, app, "appId");
        });

        // Additionally, see if it is the current and if so update it
        if (state.currentApp && state.currentApp.appId === app.appId) {
            state = {
                ...state,
                currentApp: app
            };
        }
    }

    return { ...state, appsMap, appPagesMap, errorMap };
}

function stateHasApp(state: AppState, app: ClientApp) {
    if (!app) {
        return false;
    }
    const appsMap = state.appsMap[app.organizationId];
    if (!appsMap) {
        return false;
    }
    return appsMap.find(a => a.appId === app.appId) !== undefined;
}

export function updateTemplate(state: AppState, action: UploadTemplateEndAction | UpdateTemplateEndAction): AppState {
    if (stateHasApp(state, action.payload.app)) {
        return updateApp(state, action);
    } else {
        return addAppToState(state, action);
    }
}
